/**
 * Renix App — Theme Presets
 * Each preset overrides the MUI palette `info` color (primary accent used across
 * buttons, pagination, active states, sidebar gradient) and sets sidenav defaults.
 * Brand colors (logo blue + orange) are always available via palette.brand — independent of preset.
 */

export const THEME_PRESETS = {
  renix: {
    label: "Renix",
    accentMain: "#0072D4",
    accentFocus: "#005EB3",
    gradientMain: "#339AEB",
    gradientState: "#0072D4",
    whiteSidenav: false,
    transparentSidenav: false,
  },
  zumrut: {
    label: "Zümrüt",
    accentMain: "#0d9488",
    accentFocus: "#0f766e",
    gradientMain: "#2dd4bf",
    gradientState: "#0d9488",
    whiteSidenav: false,
    transparentSidenav: false,
  },
  leylak: {
    label: "Leylak",
    accentMain: "#6366f1",
    accentFocus: "#4f46e5",
    gradientMain: "#818cf8",
    gradientState: "#6366f1",
    whiteSidenav: true,
    transparentSidenav: false,
  },
};

/** Logo colors — constant across all themes */
export const BRAND_COLORS = {
  primary: "#0072D4", // logo blue
  primaryFocus: "#005EB3",
  secondary: "#F56242", // logo orange
  secondaryFocus: "#D94E33",
};
